import { FC } from 'react'
import logger from 'lib/logger'
import { pluralize } from 'lib/text'
import Image from 'components/Image'
import Button from 'components/Button'
import Typography from 'components/Typography'
import { LOCALSTORAGE_RECOMMENDATIONS_QEV_MODAL_KEY } from 'components/QEV'
import styles from './RecommendationsBanner.module.scss'

export type TProps = {
  recommendationsLength?: number
  urlParams?: string
}

const RecommendationsBanner: FC<TProps> = ({
  recommendationsLength,
  urlParams,
}) => {
  return (
    <div className={styles.ecRecommendationsBanner}>
      <div className={styles.ecRecommendationsBannerImage}>
        <Image
          src="/img/recommendations/properties-2.webp"
          width={956}
          height={720}
          alt="Imóveis"
        />
      </div>
      <div className={styles.ecRecommendationsBannerContent}>
        <Typography bold as="h2" variant="Title">
          Recomendamos
          {recommendationsLength ? ` ${recommendationsLength} ` : ' '}
          {pluralize({
            count: recommendationsLength || 0,
            noun: 'imóvel',
            pluralNoun: 'imóveis',
          })}{' '}
          para você
        </Typography>
        <Typography>
          {recommendationsLength
            ? 'Imóveis selecionados com base na sua busca e imóveis vistos'
            : 'Imóveis selecionados com base no que procura'}
        </Typography>
        <Button
          element="a"
          href={`/recomendacoes${urlParams || ''}`}
          onClick={() => {
            localStorage.setItem(
              LOCALSTORAGE_RECOMMENDATIONS_QEV_MODAL_KEY,
              'open',
            )
            logger.action('listing-search-recommendation-button')
          }}
        >
          Ver recomendações
        </Button>
      </div>
    </div>
  )
}

export default RecommendationsBanner
